import { useEffect, useState } from 'react';

/**
 * DIE MAUS-WEICHE (Auftrag CRM-148).
 *
 * Ob das Gerät mit einem feinen Zeiger bedient wird, der überfahren kann —
 * Maus oder Trackpad am Rechner. Ein iPad mit Finger meldet `hover: none`
 * und `pointer: coarse`; schließt jemand ein Trackpad an, wechselt die
 * Abfrage, und der Hook zieht nach.
 *
 * Ohne `matchMedia` (jsdom in den Prüfungen) gilt KEIN feiner Zeiger: Was nur
 * die Maus entbehren kann, bleibt dann stehen — so sehen alle bestehenden
 * Prüfungen die Menüzeile wie bisher.
 */
export const FEINER_ZEIGER = '(hover: hover) and (pointer: fine)';

function passt(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(FEINER_ZEIGER).matches
    : false;
}

export function useFeinerZeiger(): boolean {
  const [fein, setzeFein] = useState(passt);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const abfrage = window.matchMedia(FEINER_ZEIGER);
    const beiWechsel = (): void => setzeFein(abfrage.matches);
    beiWechsel();
    abfrage.addEventListener('change', beiWechsel);
    return () => abfrage.removeEventListener('change', beiWechsel);
  }, []);
  return fein;
}
